/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommercePalletization } from "./BigCommercePalletization";
import {
  BigCommercePalletizationFromJSON,
  BigCommercePalletizationFromJSONTyped,
  BigCommercePalletizationToJSON,
  BigCommercePalletizationToJSONTyped,
} from "./BigCommercePalletization";
import type { BigCommercePickupDefaults } from "./BigCommercePickupDefaults";
import {
  BigCommercePickupDefaultsFromJSON,
  BigCommercePickupDefaultsFromJSONTyped,
  BigCommercePickupDefaultsToJSON,
  BigCommercePickupDefaultsToJSONTyped,
} from "./BigCommercePickupDefaults";
import type { CheckoutMarkup } from "./CheckoutMarkup";
import {
  CheckoutMarkupFromJSON,
  CheckoutMarkupFromJSONTyped,
  CheckoutMarkupToJSON,
  CheckoutMarkupToJSONTyped,
} from "./CheckoutMarkup";
import type { BigCommerceDeliveryDefaults } from "./BigCommerceDeliveryDefaults";
import {
  BigCommerceDeliveryDefaultsFromJSON,
  BigCommerceDeliveryDefaultsFromJSONTyped,
  BigCommerceDeliveryDefaultsToJSON,
  BigCommerceDeliveryDefaultsToJSONTyped,
} from "./BigCommerceDeliveryDefaults";
import type { BigCommerceGroupLocationTypeRule } from "./BigCommerceGroupLocationTypeRule";
import {
  BigCommerceGroupLocationTypeRuleFromJSON,
  BigCommerceGroupLocationTypeRuleFromJSONTyped,
  BigCommerceGroupLocationTypeRuleToJSON,
  BigCommerceGroupLocationTypeRuleToJSONTyped,
} from "./BigCommerceGroupLocationTypeRule";
import type { SavedPickup } from "./SavedPickup";
import {
  SavedPickupFromJSON,
  SavedPickupFromJSONTyped,
  SavedPickupToJSON,
  SavedPickupToJSONTyped,
} from "./SavedPickup";
import type { BigCommerceProductHandlingTime } from "./BigCommerceProductHandlingTime";
import {
  BigCommerceProductHandlingTimeFromJSON,
  BigCommerceProductHandlingTimeFromJSONTyped,
  BigCommerceProductHandlingTimeToJSON,
  BigCommerceProductHandlingTimeToJSONTyped,
} from "./BigCommerceProductHandlingTime";
import type { BigCommerceGroupAccessorialRule } from "./BigCommerceGroupAccessorialRule";
import {
  BigCommerceGroupAccessorialRuleFromJSON,
  BigCommerceGroupAccessorialRuleFromJSONTyped,
  BigCommerceGroupAccessorialRuleToJSON,
  BigCommerceGroupAccessorialRuleToJSONTyped,
} from "./BigCommerceGroupAccessorialRule";
import type { CheckoutRateSelector } from "./CheckoutRateSelector";
import {
  CheckoutRateSelectorFromJSON,
  CheckoutRateSelectorFromJSONTyped,
  CheckoutRateSelectorToJSON,
  CheckoutRateSelectorToJSONTyped,
} from "./CheckoutRateSelector";
import type { BigCommerceCustomerGroupRef } from "./BigCommerceCustomerGroupRef";
import {
  BigCommerceCustomerGroupRefFromJSON,
  BigCommerceCustomerGroupRefFromJSONTyped,
  BigCommerceCustomerGroupRefToJSON,
  BigCommerceCustomerGroupRefToJSONTyped,
} from "./BigCommerceCustomerGroupRef";
import type { BigCommerceProductRef } from "./BigCommerceProductRef";
import {
  BigCommerceProductRefFromJSON,
  BigCommerceProductRefFromJSONTyped,
  BigCommerceProductRefToJSON,
  BigCommerceProductRefToJSONTyped,
} from "./BigCommerceProductRef";

/**
 *
 * @export
 * @interface BigCommerceConfig
 */
export interface BigCommerceConfig {
  /**
   *
   * @type {string}
   * @memberof BigCommerceConfig
   */
  storeHash?: string | null;
  /**
   *
   * @type {string}
   * @memberof BigCommerceConfig
   */
  carrierId?: string | null;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof BigCommerceConfig
   */
  webhookSubscriptions: { [key: string]: number };
  /**
   *
   * @type {boolean}
   * @memberof BigCommerceConfig
   */
  ratesEnabled: boolean;
  /**
   *
   * @type {number}
   * @memberof BigCommerceConfig
   */
  handlingTimeBusinessDays: number;
  /**
   *
   * @type {number}
   * @memberof BigCommerceConfig
   */
  maxHandlingUnits: number;
  /**
   *
   * @type {number}
   * @memberof BigCommerceConfig
   */
  maxRatesPerResponse: number;
  /**
   *
   * @type {Array<CheckoutRateSelector>}
   * @memberof BigCommerceConfig
   */
  rateSelectors: Array<CheckoutRateSelector>;
  /**
   *
   * @type {BigCommerceDeliveryDefaults}
   * @memberof BigCommerceConfig
   */
  deliveryDefaults: BigCommerceDeliveryDefaults;
  /**
   *
   * @type {BigCommercePickupDefaults}
   * @memberof BigCommerceConfig
   */
  pickupDefaults: BigCommercePickupDefaults;
  /**
   *
   * @type {BigCommercePalletization}
   * @memberof BigCommerceConfig
   */
  palletization: BigCommercePalletization;
  /**
   *
   * @type {Array<BigCommerceCustomerGroupRef>}
   * @memberof BigCommerceConfig
   */
  requiredCustomerGroups: Array<BigCommerceCustomerGroupRef>;
  /**
   *
   * @type {Array<BigCommerceGroupAccessorialRule>}
   * @memberof BigCommerceConfig
   */
  groupAccessorialRules: Array<BigCommerceGroupAccessorialRule>;
  /**
   *
   * @type {Array<BigCommerceGroupLocationTypeRule>}
   * @memberof BigCommerceConfig
   */
  groupLocationTypeRules: Array<BigCommerceGroupLocationTypeRule>;
  /**
   *
   * @type {Array<BigCommerceProductRef>}
   * @memberof BigCommerceConfig
   */
  excludedProducts: Array<BigCommerceProductRef>;
  /**
   *
   * @type {Array<BigCommerceProductHandlingTime>}
   * @memberof BigCommerceConfig
   */
  productHandlingTimes: Array<BigCommerceProductHandlingTime>;
  /**
   *
   * @type {Array<string>}
   * @memberof BigCommerceConfig
   */
  allowedCarriers: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BigCommerceConfig
   */
  blockedCarriers: Array<string>;
  /**
   *
   * @type {CheckoutMarkup}
   * @memberof BigCommerceConfig
   */
  markup: CheckoutMarkup;
  /**
   *
   * @type {SavedPickup}
   * @memberof BigCommerceConfig
   */
  bookingPickup?: SavedPickup | null;
}

/**
 * Check if a given object implements the BigCommerceConfig interface.
 */
export function instanceOfBigCommerceConfig(
  value: object,
): value is BigCommerceConfig {
  if (
    !("webhookSubscriptions" in value) ||
    value["webhookSubscriptions"] === undefined
  )
    return false;
  if (!("ratesEnabled" in value) || value["ratesEnabled"] === undefined)
    return false;
  if (
    !("handlingTimeBusinessDays" in value) ||
    value["handlingTimeBusinessDays"] === undefined
  )
    return false;
  if (!("maxHandlingUnits" in value) || value["maxHandlingUnits"] === undefined)
    return false;
  if (
    !("maxRatesPerResponse" in value) ||
    value["maxRatesPerResponse"] === undefined
  )
    return false;
  if (!("rateSelectors" in value) || value["rateSelectors"] === undefined)
    return false;
  if (!("deliveryDefaults" in value) || value["deliveryDefaults"] === undefined)
    return false;
  if (!("pickupDefaults" in value) || value["pickupDefaults"] === undefined)
    return false;
  if (!("palletization" in value) || value["palletization"] === undefined)
    return false;
  if (
    !("requiredCustomerGroups" in value) ||
    value["requiredCustomerGroups"] === undefined
  )
    return false;
  if (
    !("groupAccessorialRules" in value) ||
    value["groupAccessorialRules"] === undefined
  )
    return false;
  if (
    !("groupLocationTypeRules" in value) ||
    value["groupLocationTypeRules"] === undefined
  )
    return false;
  if (!("excludedProducts" in value) || value["excludedProducts"] === undefined)
    return false;
  if (
    !("productHandlingTimes" in value) ||
    value["productHandlingTimes"] === undefined
  )
    return false;
  if (!("allowedCarriers" in value) || value["allowedCarriers"] === undefined)
    return false;
  if (!("blockedCarriers" in value) || value["blockedCarriers"] === undefined)
    return false;
  if (!("markup" in value) || value["markup"] === undefined) return false;
  return true;
}

export function BigCommerceConfigFromJSON(json: any): BigCommerceConfig {
  return BigCommerceConfigFromJSONTyped(json, false);
}

export function BigCommerceConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceConfig {
  if (json == null) {
    return json;
  }
  return {
    storeHash: json["storeHash"] == null ? undefined : json["storeHash"],
    carrierId: json["carrierId"] == null ? undefined : json["carrierId"],
    webhookSubscriptions: json["webhookSubscriptions"],
    ratesEnabled: json["ratesEnabled"],
    handlingTimeBusinessDays: json["handlingTimeBusinessDays"],
    maxHandlingUnits: json["maxHandlingUnits"],
    maxRatesPerResponse: json["maxRatesPerResponse"],
    rateSelectors: (json["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorFromJSON,
    ),
    deliveryDefaults: BigCommerceDeliveryDefaultsFromJSON(
      json["deliveryDefaults"],
    ),
    pickupDefaults: BigCommercePickupDefaultsFromJSON(json["pickupDefaults"]),
    palletization: BigCommercePalletizationFromJSON(json["palletization"]),
    requiredCustomerGroups: (json["requiredCustomerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefFromJSON,
    ),
    groupAccessorialRules: (json["groupAccessorialRules"] as Array<any>).map(
      BigCommerceGroupAccessorialRuleFromJSON,
    ),
    groupLocationTypeRules: (json["groupLocationTypeRules"] as Array<any>).map(
      BigCommerceGroupLocationTypeRuleFromJSON,
    ),
    excludedProducts: (json["excludedProducts"] as Array<any>).map(
      BigCommerceProductRefFromJSON,
    ),
    productHandlingTimes: (json["productHandlingTimes"] as Array<any>).map(
      BigCommerceProductHandlingTimeFromJSON,
    ),
    allowedCarriers: json["allowedCarriers"],
    blockedCarriers: json["blockedCarriers"],
    markup: CheckoutMarkupFromJSON(json["markup"]),
    bookingPickup:
      json["bookingPickup"] == null
        ? undefined
        : SavedPickupFromJSON(json["bookingPickup"]),
  };
}

export function BigCommerceConfigToJSON(json: any): BigCommerceConfig {
  return BigCommerceConfigToJSONTyped(json, false);
}

export function BigCommerceConfigToJSONTyped(
  value?: BigCommerceConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    storeHash: value["storeHash"],
    carrierId: value["carrierId"],
    webhookSubscriptions: value["webhookSubscriptions"],
    ratesEnabled: value["ratesEnabled"],
    handlingTimeBusinessDays: value["handlingTimeBusinessDays"],
    maxHandlingUnits: value["maxHandlingUnits"],
    maxRatesPerResponse: value["maxRatesPerResponse"],
    rateSelectors: (value["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorToJSON,
    ),
    deliveryDefaults: BigCommerceDeliveryDefaultsToJSON(
      value["deliveryDefaults"],
    ),
    pickupDefaults: BigCommercePickupDefaultsToJSON(value["pickupDefaults"]),
    palletization: BigCommercePalletizationToJSON(value["palletization"]),
    requiredCustomerGroups: (value["requiredCustomerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefToJSON,
    ),
    groupAccessorialRules: (value["groupAccessorialRules"] as Array<any>).map(
      BigCommerceGroupAccessorialRuleToJSON,
    ),
    groupLocationTypeRules: (value["groupLocationTypeRules"] as Array<any>).map(
      BigCommerceGroupLocationTypeRuleToJSON,
    ),
    excludedProducts: (value["excludedProducts"] as Array<any>).map(
      BigCommerceProductRefToJSON,
    ),
    productHandlingTimes: (value["productHandlingTimes"] as Array<any>).map(
      BigCommerceProductHandlingTimeToJSON,
    ),
    allowedCarriers: value["allowedCarriers"],
    blockedCarriers: value["blockedCarriers"],
    markup: CheckoutMarkupToJSON(value["markup"]),
    bookingPickup: SavedPickupToJSON(value["bookingPickup"]),
  };
}
